<template>
  <div>
    <div class="rounded border border-gray-400 bg-white max-w-3xl text-sm">
      <dl>
        <div class="bg-gray-100 p-5 rounded-t lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Agency</dt>
          <dd class="col-span-3">{{ agencyName }}</dd>
        </div>

        <div class="bg-white p-5 rounded-t lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Membership product</dt>
          <dd class="col-span-3">{{ membershipProductName }}</dd>
        </div>

        <div class="bg-gray-100 p-5 lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Date Start</dt>
          <dd class="col-span-3">
            {{ dateStart }}
          </dd>
        </div>

        <div class="bg-white p-5 rounded-b lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Billing</dt>
          <dd class="col-span-3">
            {{ billing }}
          </dd>
        </div>

        <div class="bg-gray-100 p-5 rounded-b lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Strategic Priority</dt>
          <dd class="col-span-3">
            {{ accountSubscription.strategicPriority }}
          </dd>
        </div>

        <div class="bg-white p-5 rounded-b lg:grid lg:grid-cols-4">
          <dt class="text-gray-600">Products</dt>
          <dd class="col-span-3">
            {{ accountSubscription.products }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pluralize from 'pluralize';
import moment from 'moment';

export default {
  name: 'AccountSubscriptionDetailsPage',

  computed: {
    ...mapGetters('ui/accountSubscriptions', ['accountSubscription']),
    agencyName() {
      return (
        this.$store.state.entities.accounts.byId[this.accountSubscription.agencyUuid]?.name ||
        'Unknown agency'
      );
    },
    membershipProductName() {
      const { membershipProduct } = this.accountSubscription;

      if (typeof membershipProduct === 'undefined') {
        return 'Unknown';
      }

      return membershipProduct?.name || 'Unknown membership product name';
    },
    dateStart() {
      return moment(this.accountSubscription.dateStart).format('DD/MM/YYYY');
    },
    billing() {
      const { billingPeriod, billingInterval, billingLength, billingAmount, minCharges } =
        this.accountSubscription;

      const totalAmount = (billingAmount || 0) + (minCharges || 0);

      const parts = [
        ...(totalAmount ? [`${totalAmount} €`] : []),
        'every',
        billingInterval,
        pluralize(billingPeriod, billingInterval),
        'for a total of',
        billingLength * billingInterval,
        pluralize(billingPeriod, billingLength * billingInterval),
      ];
      return parts.join(' ');
    },
  },
};
</script>
